import "es6-promise/auto";
import Vue from "vue";
import Axios from "axios";
import Common from "../components/common.js";
import CompPager from "../components/paging.vue";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/ko"; // 한글 로케일 추가
import Cleave from "vue-cleave-component";

Vue.component("pager", CompPager);
Vue.component("common", Common);

new Vue({
  el: "#homepage-lost-list",
  data: function() {
    return {
      viewModel: {
        list: [],
        startDate: "",
        endDate: "",
        stat: "",
        title: "",
        pager: {
          model: {},
          pageNo: 1,
          totalSize: 0,
          rowSize: 10,
          blockSize: 10,
          list: [],
          callBack: function(n) {
            this.model.fnInit();
          }
        }
      }
    };
  },
  components: { DatePicker },
  computed: {},
  watch: {},
  mounted: function() {
    console.log("mounted [homepage-lost-list]");
    let vm = this;
    try {
      vm.fnInit();
    } catch (e) {
      console.log(e);
    }
  },
  methods: {
    fnInit: function() {
      let vm = this;
      Axios.post("/club/lost/list", { pageNo: vm.viewModel.pager.pageNo, pageSize: vm.viewModel.pager.rowSize, title: vm.viewModel.title, startDate: vm.viewModel.startDate, endDate: vm.viewModel.endDate, stat: vm.viewModel.stat })
        .then(function(response) {
          let rs = response.data;
          vm.viewModel.list = rs.listLost;
          vm.viewModel.pager.totalSize = rs.totalCount;
          vm.viewModel.pageNum = vm.viewModel.pager.pageNo * vm.viewModel.pager.rowSize - vm.viewModel.pager.rowSize;
          CompPager.props = CompPager.methods.createPaging(vm.viewModel.pager, vm, "list");
        })
        .catch(function(ex) {
          console.log(ex);
        });
    },
  }
});



// WEBPACK FOOTER //
// ./src/homepage/homepage-lost-list-controller.js